export const GEIST_FONT = 'Geist';
export const ROBOTO_MONO_FONT = 'Roboto Mono';
